import { Paragraph } from "@sicredi/react";
import { ReactElement } from "react";
import styles from "./styles.module.scss";

type TextContratoProps = {
  order: number;
  img: string;
  description: string | ReactElement;
};

export const TextContrato: React.FC<TextContratoProps> = ({
  order,
  img,
  description,
}) => {
  return (
    <div className={styles.info}>
      <div className={styles.ordering}>
        <img className={styles.img} src={img} alt={"imagem de icone"} />
        <span className={styles.number}>{order}</span>
      </div>
      <Paragraph>{description}</Paragraph>
    </div>
  );
};
